import { Modal } from "@shop/frontend/web/js/components/Modal";

export class EventView {
	constructor() {
		this.$popupModal = null;
		this.$placesContainer = $("#js-places");
		this.modal = new Modal({ className: "i-modal_mobile-fixed", id: "popup-event" });
		this.modalAlert = new Modal({ className: "i-modal_alert", id: "alert-modal" });
	}

	getPlacesSettings() {
		const settings = {};

		if (this.$placesContainer.attr("data-show-free-places") === "0")
			settings.showFreePlaces = false;
		if (this.$placesContainer.attr("data-price-filter-type"))
			settings.planPriceFilterType = parseInt(
				this.$placesContainer.attr("data-price-filter-type")
			);
		if (this.$placesContainer.attr("data-has-child-ticket") === "true")
			settings.hasChildTicket = true;

		return settings;
	}

	showEventOnPopup() {
		let places = $("#js-places");
		let notification = $(".notification");
		let notificationEntrance = $(".notification-entrance");
		const htmlObject = document.createElement("div");
		htmlObject.innerHTML = places.appendTo("<div></div>").html();

		if (places.find(".places__content").hasClass("places_service") && (notification || notificationEntrance)) {
			notification.appendTo(htmlObject).html()
			notificationEntrance.appendTo(htmlObject).html()
		}

		this.modal.show(htmlObject);
		this.$popupModal = $(".i-modal_mobile-fixed");
		this.$popupModal.find(".places__content").wrap("<div id='js-places'></div>");
		this.$popupModal.find(".places__top").show();

		this.$popupModal.find(".places__middle").append($(".js-stadium-zones"));
		this.$popupModal.find(".places__middle").append($(".js-places-prices"));

		this.modal.on("hide", () => window.location.assign("/"));
	}

	returnEventFromPopup() {
		$(".events_page").after($("#js-places"));

		$("#js-places-check-price").after($(".js-stadium-zones"));
		$("#js-places-check-price").after($(".js-places-prices"));

		$(".places__top").hide();
		this.$popupModal.find(".modal-body").html("");
		this.$popupModal.removeClass("i-modal_mobile-fixed");
		this.$popupModal.modal("hide");
	}

	showChildTicketInfo() {
		if (!localStorage.getItem("change_price_id_alert")) {
			const isSeason = $(".events_page").data("is-season");
			const word = isSeason ? "абонемент" : "билет";
			this.modalAlert.show(
				`
					<h3>Обратите внимание!</h3>
					<p class="mb-0">Доступен ${word} для детей от 7 до 14 лет с 50% скидкой, приобрести его можно только в паре со взрослым (-сопровождающим).</p>
					<label class="checkbox mt-4 mb-4 d-inline-flex">
              <input type="checkbox" name="show_price_id_alert_discount" class="checkbox__input" checked />
              <span class="checkbox__custom"></span>
              <span class="checkbox__block">Не показывать это сообщение</span>
          </label>
          <br>
          <button class="btn js-price-id-alert-btn" data-bs-dismiss="modal">Продолжить</button>
				`
			);

			$(".js-price-id-alert-btn").on("click", () => {
				if ($("input[name='show_price_id_alert_discount']").is(":checked")) {
					localStorage.setItem("change_price_id_alert", "true");
				}
			});
		}
	}

	updateTextSize() {
		$("#js-change-svg")
			.find("svg > text")
			.each((i, item) => {
				let fontSize = parseFloat($(item).css("font-size"));
				fontSize += 2;
				$(item).css("font-size", fontSize + "px");
			});
	}
}
